<template>
  <div class="producttracker-data">
    <div class="product-container">
      <div class="row m-0">
        <div class="col-sm-4 col-lg-6 col-xs-12 p-0">
          <span class="title">Product Tracker</span>
        </div>
        <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12 p-0 xs-mt-20 custom-display">
          <div
            class="wd-370"
            :class="{
              'mr-20': permissions.includes(
                'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_ADD_NEW_PRODUCT'
              )
            }"
          >
            <search-box v-model="searchText" @getList="getList()"></search-box>
          </div>
          <button
            v-if="permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_ADD_NEW_PRODUCT')"
            data-toggle="modal"
            data-target="#confrimAddPopup"
            class="btn emergo-green-button"
          >
            <img
              src="/static/images/icons/plus_icon.svg"
              class="margin-btn-plus-icon"
              alt="plus-icon"
            />Add <span class="hidden-xs">New Product</span>
          </button>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-xs-12 p-0">
          <div class="header_box pb-20">
            <div class="row">
              <div class="col-xs-12">
                <div class="flex">
                  <p class="pr-30 xs-pr-10">
                    With the Product Tracker you can manage the products that are being represented
                    by Emergo. You can request additions, modifications, and removals of product
                    families to and from your representation agreement. The product tracker will
                    indicate the status of each product family. Only product families with a status
                    of "Represented" or "Registered and Represented" can be marketed by you with
                    Emergo as the in-country representative. You can see a definition of each status
                    by clicking on the information icon on the right.
                    <br />The product tracker is currently being used for representation in
                    Australia, the EU, Switzerland, and the UK.
                  </p>
                  <el-popover
                    placement="bottom-end"
                    trigger="click"
                    popper-class="popup-background xs-popup-background pl-18"
                    @show="infoActive = true"
                    @hide="infoActive = false"
                    width="600"
                  >
                    <!-- <template #reference> -->
                    <img
                      class="info-img pr-10"
                      src="/static/images/icons/info_icon.svg"
                      v-if="!infoActive"
                      alt="info-icon"
                      slot="reference"
                    />
                    <img
                      class="info-img pr-10"
                      src="/static/images/icons/info_icon_active.svg"
                      v-if="infoActive"
                      alt="infoactive-icon"
                      slot="reference"
                    />
                    <!-- </template> -->
                    <div class="info-tabs">
                      <p class="info-tabs-header">Product Status information:</p>
                      <ul class="pt-10 pl-20 pr-20">
                        <li v-for="(role, index) in metaData.work_flow_statuses" :key="index">
                          <div class="info-text">
                            <span class="role-name">{{ role.name }}:</span>
                            <span class="role-desc"> {{ role.description }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-xs-12 p-0">
          <div class="header_box">
            <div class="row m-0">
              <div class="col-sm-5 pl-0">
                <p class="product-count">{{ products.length || 0 }} Products</p>
              </div>
              <div
                class="col-sm-7 p-0 display-flex sm-justify-content-end xs-mt-20"
                v-if="products.length || isRemovedflag || total"
              >
                <a
                  v-if="
                    permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_UPDATE')
                  "
                  class="cursor-pointer pr-20"
                  :disabled="selectedProducts.length < 2 || isRemovedflag"
                  @click="openRequestModification('bulk')"
                >
                  <img
                    src="/static/images/icons/modification_icon.svg"
                    alt
                    class="header-img-size"
                  />
                  <span class="header-font text-emergo-dark-blue"> Bulk Request Update </span>
                </a>
                <!-- <a
                  v-if="
                    permissions.includes(
                      'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_REMOVAL'
                    ) && products.length && !isRemovedflag
                  "
                  class="cursor-pointer"
                  :disabled="selectedProducts.length < 2"
                  @click="openClientRemovalPopup('bulk', null)"
                >
                  <img
                    src="/static/images/icons/delete_icon.svg"
                    alt
                    class="header-img-size"
                  />
                  <span class="header-font text-emergo-red">
                    Bulk Request Removal
                  </span>
                </a> -->
                <!-- <a
                  v-if="
                    permissions.includes(
                      'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REMOVE_PRODUCT'
                    )
                  "
                  class="cursor-pointer"
                  :disabled="selectedProducts.length < 2"
                  @click="
                    openRemovalPopup('bulk', null)
                  "
                >
                  <img
                    src="/static/images/icons/delete_icon.svg"
                    alt
                    class="header-img-size"
                  />
                  <span class="header-font text-emergo-red">
                    Bulk Remove Product
                  </span>
                </a> -->
                <div v-if="total || isRemovedflag">
                  <span class="checkbox mr-12 top-4">
                    <label>
                      <input type="checkbox" v-model="isRemovedflag" @change="removeSelected" />
                      <span class="cr"></span>
                    </label>
                  </span>
                  <span class="header-font removed-label text-emergo-dark-blue">
                    Show Removed
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-0" v-if="metaData.product_tracker_countries && total && checkAllMarkets()">
        <div class="col-xs-12 p-0">
          <ul class="horizontal-tabs d-flex pl-10 mt-10">
            <template v-for="country in metaData.product_tracker_countries">
              <li
                :key="country.country_id"
                @click="setTab(country.country_id)"
                class="cursor-pointer"
                :class="{
                  active: activeTab === country.country_id
                }"
                v-if="checkCountFromMarkets(country.country_id)"
              >
                {{ country.name }}
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div class="row m-0 position-relative" v-if="products.length">
      <div class="col-xs-12 p-0">
        <div class="rep_resources_table">
          <table class="table">
            <thead>
              <tr :class="{ 'custom-padding': !checkRolePermissions }">
                <template v-if="checkRolePermissions">
                  <th
                    class="filter-th wd-65 sticky"
                    :class="{ 'border-shadow': [12, 13].includes(roleId) }"
                  ></th>
                  <th class="sticky-checkbox wd-40" v-if="![12, 13].includes(roleId)">
                    <span class="checkbox top-2">
                      <label>
                        <input
                          type="checkbox"
                          v-model="selectAllProducts"
                          @change="selectAll()"
                          :disabled="isRemovedflag"
                        />
                        <span class="cr"></span>
                      </label>
                    </span>
                  </th>
                </template>
                <template v-for="header in headers">
                  <th
                    :key="header.key"
                    :width="getHeaderWidth(header)"
                    v-if="!((activeTab === 14 || activeTab === 216) && header.key === 'directives')"
                  >
                    {{ header.name }}
                    <span
                      class="sort"
                      @click="sortBy(header.key)"
                      :class="sortOrders[header.key] > 0 ? 'asc' : 'desc'"
                      v-if="header.key !== 'directives' && header.key !== 'trade_name'"
                      ><img src="/static/images/icons/sortDesc.svg"
                    /></span>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="(each, index) in products">
                <tr :key="index" :class="{ 'custom-padding': !checkRolePermissions }">
                  <template v-if="checkRolePermissions">
                    <td class="menu-td sticky" :class="{ 'border-shadow': [12, 13].includes(roleId) }">
                      <div
                        :id="'trackerActionDots' + index"
                        class="dropdown dropdown-export export-activity-menu text-center"
                        :class="{
                          'disable-three-dots': !checkMenuPermission(each.workflow_status_id)
                        }"
                      >
                        <div
                          :data-toggle="
                            checkMenuPermission(each.workflow_status_id) ? 'dropdown' : false
                          "
                          @click="
                            checkMenuPermission(each.workflow_status_id)
                              ? menuDropdown($event)
                              : null
                          "
                        >
                          <div class="dropdown-toggle"></div>
                        </div>
                        <template v-if="each.workflow_status_id !== 6">
                          <ul class="dropdown-menu" v-bind:class="changeClass ? 'addReverse' : ''">
                            <template v-if="each.workflow_status_id > 1">
                              <li>
                                <a
                                  class="text-color-blue menu-dots-links"
                                  @click="openInfoPopup(each)"
                                >
                                  <img
                                    src="/static/images/icons/info_icon.svg"
                                    class="tracker-images"
                                    alt="convertion-icon"
                                  />
                                  <span>Info</span>
                                </a>
                              </li>
                            </template>
                            <template v-if="each.workflow_status_id > 1">
                              <li>
                                <a
                                  class="text-color-blue menu-dots-links"
                                  @click="openContactsInfoPopup(each)"
                                  :disabled="each.workflow_status_id > 5"
                                >
                                  <img
                                    src="/static/images/icons/info_icon.svg"
                                    class="tracker-images"
                                    alt="convertion-icon"
                                  />
                                  <span>Project Contacts</span>
                                </a>
                              </li>
                            </template>
                            <template
                              v-if="
                                each.workflow_status_id === 1 &&
                                permissions.includes(
                                  'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_DRAFT'
                                )
                              "
                            >
                              <li>
                                <a
                                  class="text-color-blue menu-dots-links"
                                  @click="editProductTracker(each.id, each.country_id)"
                                >
                                  <img
                                    src="/static/images/icons/edit_icon.svg"
                                    class="tracker-images"
                                    alt="convertion-icon"
                                  />
                                  <span>Edit Draft</span>
                                </a>
                              </li>
                            </template>
                            <template
                              v-if="
                                each.workflow_status_id > 1 &&
                                each.workflow_status_id !== 5 &&
                                permissions.includes(
                                  'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_PRODUCT'
                                )
                              "
                            >
                              <li>
                                <a
                                  class="text-color-blue menu-dots-links"
                                  @click="editProductTracker(each.id, each.country_id)"
                                >
                                  <img
                                    src="/static/images/icons/edit_icon.svg"
                                    class="tracker-images"
                                    alt="convertion-icon"
                                  />
                                  <span>Edit Product</span>
                                </a>
                              </li>
                            </template>
                            <template
                              v-if="
                                each.workflow_status_id > 1 &&
                                permissions.includes(
                                  'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_UPDATE'
                                )
                              "
                            >
                              <li>
                                <a
                                  class="text-color-blue menu-dots-links"
                                  href="javascript:void(0);"
                                  @click="openRequestModification('single', each)"
                                >
                                  <img
                                    src="/static/images/icons/modification_icon.svg"
                                    class="tracker-images"
                                    alt="convertion-icon"
                                  />
                                  <span>Request Update</span>
                                </a>
                              </li>
                            </template>
                            <template
                              v-if="
                                each.workflow_status_id > 1 &&
                                permissions.includes(
                                  'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_REMOVAL'
                                )
                              "
                            >
                              <li>
                                <a
                                  class="text-color-delete-red menu-dots-links"
                                  @click="openClientRemovalPopup('single', each)"
                                >
                                  <img
                                    src="/static/images/icons/delete_icon.svg"
                                    class="tracker-images"
                                    alt="delete-icon"
                                  />
                                  <span>Request Removal</span>
                                </a>
                              </li>
                            </template>
                            <template
                              v-if="
                                each.workflow_status_id > 1 &&
                                each.workflow_status_id !== 5 &&
                                permissions.includes(
                                  'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REMOVE_PRODUCT'
                                )
                              "
                            >
                              <li v-if="each.client_initiated_delete">
                                <el-tooltip
                                  class="item"
                                  effect="light"
                                  content="Allows the removal of a Product family after a client submitted a removal request via RAMS"
                                  placement="top-start"
                                >
                                  <a
                                    class="text-color-delete-red menu-dots-links"
                                    @click="
                                      openRemovalPopup('single', each, 'client_initiated_delete')
                                    "
                                  >
                                    <img
                                      src="/static/images/icons/delete_icon.svg"
                                      class="tracker-images"
                                      alt="delete-icon"
                                    />
                                    <span>Remove Product</span>
                                  </a>
                                </el-tooltip>
                              </li>
                              <li>
                                <el-tooltip
                                  class="item"
                                  effect="light"
                                  content="Initiates the removal by PM. Client will receive an email, asking for confirmation of the removal."
                                  placement="bottom-start"
                                >
                                  <a
                                    class="text-color-delete-red menu-dots-links"
                                    @click="
                                      openPMRequestRemovalPopup(
                                        'single',
                                        each,
                                        'client_initiated_delete'
                                      )
                                    "
                                  >
                                    <img
                                      src="/static/images/icons/delete_icon.svg"
                                      class="tracker-images"
                                      alt="delete-icon"
                                    />
                                    <span>Request Removal</span>
                                  </a>
                                </el-tooltip>
                              </li>
                            </template>
                          </ul>
                        </template>
                        <template v-else>
                          <ul class="dropdown-menu" v-bind:class="changeClass ? 'addReverse' : ''">
                            <template v-if="each.workflow_status_id > 1">
                              <li>
                                <a
                                  class="text-color-blue menu-dots-links"
                                  @click="openInfoPopup(each)"
                                >
                                  <img
                                    src="/static/images/icons/info_icon.svg"
                                    class="tracker-images"
                                    alt="convertion-icon"
                                  />
                                  <span>Info</span>
                                </a>
                              </li>
                            </template>
                          </ul>
                        </template>
                      </div>
                    </td>
                    <td class="sticky-checkbox" v-if="![12, 13].includes(roleId)">
                      <span class="checkbox top-2">
                        <label>
                          <input
                            type="checkbox"
                            v-model="selectedProducts"
                            :value="each"
                            @change="updateSelection(each, $event)"
                            :disabled="[1,5,6].includes(each.workflow_status_id) ||
                              !checkMenuPermission(each.workflow_status_id)
                            "
                          /><span class="cr"></span>
                        </label>
                      </span>
                    </td>
                  </template>
                  <template v-for="(header, indexes) in headers">
                    <template
                      v-if="
                        !((activeTab === 14 || activeTab === 216) && header.key === 'directives')
                      "
                    >
                      <td v-if="Array.isArray(each[header.key])" :key="indexes">
                        <el-popover
                          v-if="each[header.key].length > 1"
                          placement="bottom"
                          trigger="hover"
                          visible-arrow="true"
                          popper-class="custom-tradelist-popover"
                        >
                          <div slot="reference">
                            <template v-for="(name, i) in each[header.key].slice(0, 5)">
                              <span :key="i">
                                {{ name
                                }}{{ i !== each[header.key].slice(0, 5).length - 1 ? ', ' : '' }}
                              </span>
                            </template>
                            <span v-if="each[header.key].length > 5" class="ft-20">...</span>
                          </div>
                          <div class="list">
                            <template v-for="(name, i) in each[header.key]">
                              <div class="ft-16" :key="i">
                                {{ name }}{{ i !== each[header.key].length - 1 ? ', ' : '' }}
                              </div>
                            </template>
                          </div>
                        </el-popover>
                        <template v-else v-for="(name, i) in each[header.key]">
                          <span :key="i">
                            {{ name }}{{ i !== each[header.key].length - 1 ? ', ' : '' }}
                          </span>
                        </template>
                      </td>
                      <td v-else-if="header.key === 'workflow_status_id'" :key="indexes">
                        <multiselect
                          :showLabels="false"
                          :close-on-select="true"
                          :allow-empty="false"
                          class="multiselect-single-dropdown status-dropdown"
                          :class="
                            each[header.key] === 1 ||
                            each[header.key] === 5 ||
                            each[header.key] === 6
                              ? 'disable-drop-down'
                              : ''
                          "
                          :searchable="false"
                          :options="filteredOptions(each[header.key])"
                          label="name"
                          :value="getStatus(each[header.key])"
                          placeholder="Select Status"
                          @select="updateStatusCall($event, each)"
                          v-if="
                            metaData.work_flow_statuses &&
                            permissions.includes(
                              'REPRESENTATION_RESOURCES_PRODUCT_TRACKER_CHANGE_STATUS'
                            )
                          "
                          :disabled="
                            each[header.key] === 1 ||
                            each[header.key] === 5 ||
                            each[header.key] === 6
                          "
                        >
                          <div slot="option" slot-scope="props">
                            {{ props.option.name }}
                          </div>
                          <div slot="noResult">No matching data</div>
                        </multiselect>
                        <div v-else>
                          <span>{{ getStatusName(each[header.key]) }}</span>
                          <div
                            v-if="each[header.key] === 5 && each.pm_delete_request_to_id === userId"
                            class="pt-10"
                          >
                            <a
                              href="javascript:void(0);"
                              class="text-color-blue custom-margin-right fw-500"
                              @click="approvedRequest('approval', each)"
                              >Approve</a
                            >
                            <a
                              href="javascript:void(0);"
                              class="text-emergo-red fw-500"
                              @click="approvedRequest('denial', each)"
                              >Deny</a
                            >
                          </div>
                        </div>
                      </td>
                      <td v-else :key="indexes">{{ each[header.key] }}</td>
                    </template>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      class="row m-0 mt-10"
      v-if="((!products.length && !this.searchText) || !total) && initialCalls"
    >
      <div class="notification_box">
        <div class="row m-0 center">
          <div class="col-xs-12">
            <img src="/static/images/icons/info_icon.svg" width="32px" height="32px" />
          </div>
          <div class="col-xs-12 notification_text">
            No product have been <br />
            {{ isRemovedflag ? 'removed' : 'added' }} yet.
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 mt-10" v-if="!products.length && this.searchText && initialCalls">
      <div class="notification_box">
        <div class="row m-0 center">
          <div class="col-xs-12">
            <img src="/static/images/icons/info_icon.svg" width="32px" height="32px" />
          </div>
          <div class="col-xs-12 notification_text">No products found.</div>
        </div>
      </div>
    </div>
    <!-- <div class="row m-0">
      <pagination
        :totalPages="totalPages"
        :maxVisibleButtons="maxVisiblePages"
        :total="total"
        :perPage="perPage"
        :currentPage="currentPage"
        @pagechanged="pagechanged"
      ></pagination>
    </div> -->
    <div id="requestModificationPopup" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <span>Request Update</span>
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              @click="closeRequestPopup"
            />
          </div>
          <div class="modal-body generic-body">
            <div class="">
              <div class="form-group">What kind of modifications would you like to make?</div>
              <textarea
                class="form-control text-box"
                v-model.trim="requestModificationMessage"
                placeholder="Message"
              />
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="closeRequestPopup"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                data-toggle="modal"
                data-target="#clientModificationRequestConfirmationPopup"
                :disabled="!requestModificationMessage"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="clientModificationRequestConfirmationPopup"
      class="modal fade submit-popup"
      role="dialog"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#clientModificationRequestConfirmationPopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/expiring_yellow.svg" class="info-icon" />
            <div class="sub-header">Are you sure you want to submit the modification request?</div>
            <div class="sub-text">
              This will send an email to Project Manager for modifications.
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#clientModificationRequestConfirmationPopup"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="requestModification"
              >
                Submit
              </button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'requestModification'"></loader>
        </div>
      </div>
    </div>
    <div id="clientRequestRemovalPopup" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#clientRequestRemovalPopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/expiring_yellow.svg" class="info-icon" />
            <div class="sub-header">Are you sure you want to submit the removal request?</div>
            <div class="sub-text">
              This will send an email to Project Manager for removal. Once they delete the product,
              Emergo will no longer represent you for this product but the information will remain
              in the product tracker.
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#clientRequestRemovalPopup"
                @click="
                  selectedProductType = '';
                  selectedSingleProduct = null;
                "
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="submitRequestRemoval()"
              >
                Submit
              </button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'requestRemoveProduct'"></loader>
        </div>
      </div>
    </div>
    <div id="confirmProductRemoval" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#confirmProductRemoval"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/expiring_yellow.svg" class="info-icon" />
            <div class="sub-header">
              Are you sure you would like to delete the selected product(s)?
            </div>
            <div class="sub-text">
              <div>
                Once deleted, you cannot recover the <br />
                information again.
              </div>
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#confirmProductRemoval"
                @click="
                  selectedProductType = '';
                  selectedSingleProduct = null;
                "
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="removeSelectedProducts()"
              >
                Submit
              </button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'removeProduct'"></loader>
        </div>
      </div>
    </div>
    <div id="approveRequestPopup" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#approveRequestPopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/expiring_yellow.svg" class="info-icon" />
            <div class="sub-header">
              Are you sure you would like to
              {{ this.selectedProductType === 'approval' ? 'approve' : 'deny' }} this request?
            </div>
            <div class="sub-text">
              <div>
                Once you proceed, you will not be able to undo the action. PM will be notified about
                the {{ this.selectedProductType }}.
              </div>
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#approveRequestPopup"
                @click="
                  selectedProductType = '';
                  selectedSingleProduct = null;
                "
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="approvedProductRequest()"
              >
                {{ this.selectedProductType === 'approval' ? 'Approve' : 'Deny' }}
              </button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'approveProduct'"></loader>
        </div>
      </div>
    </div>
    <div id="requestRemoveProductPopup" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header pb-15">
            <span>Select Contacts to Notify</span>
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="requestRemoveProductPopup"
              @click="(primaryUser = null), (secondaryUsers = [])"
            />
          </div>
          <div class="modal-body generic-body">
            <div class="row mb-10">
              <p class="col-xs-12 modal-status-header pr-0">
                Please select the required contacts before removing products:
              </p>
              <p class="col-xs-12 modal-note pr-0">
                The selected contacts will be notified after the removal is initiated.
              </p>
            </div>
            <div class="row mb-15">
              <div class="input-label col-xs-12">To<span class="required-astreisk">*</span></div>
              <div class="col-xs-12">
                <multiselect
                  :showLabels="false"
                  :close-on-select="true"
                  class="multiselect-single-dropdown"
                  :class="!primaryUser ? 'un-selected' : ''"
                  :searchable="true"
                  :options="usersList.map((e) => e.user_id)"
                  :custom-label="getUserFullName"
                  v-model="primaryUser"
                  placeholder="Select Contact"
                >
                  <span slot="noResult">No matching data</span>
                </multiselect>
              </div>
              <div v-if="primaryUser" class="mt-20 col-xs-12">
                <span class="selected-names text-capitalize mb-20">
                  {{ getContact(primaryUser).first_name }}
                  {{ getContact(primaryUser).last_name }}
                  <img
                    src="/static/images/icons/close_blue_icon.svg"
                    class="ml-10 cursor-pointer"
                    @click="primaryUser = null"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="requestRemoveProductPopup"
                @click="(primaryUser = null), (secondaryUsers = [])"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="removeProductRequestByPM"
                :disabled="!primaryUser"
              >
                Proceed
              </button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'requestRemoveProductPopup'"></loader>
        </div>
      </div>
    </div>
    <div id="productTrackerInfoPopup" class="modal fade" role="dialog">
      <div class="modal-dialog info-popup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <span>Info</span>
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="productTrackerInfoPopup"
              @click="productInfoData = []"
            />
          </div>
          <div class="modal-body generic-body">
            <div class="modal-status-header pt-15">Status updates:</div>
            <div class="info-table">
              <table class="table status-table mt-20">
                <thead>
                  <tr :class="{ 'custom-padding': !checkRolePermissions }">
                    <template v-for="(header, index) in infoheaders">
                      <th :key="index">{{ header.name }}</th></template
                    >
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in productInfoData" :key="index">
                    <template v-for="(header, headerindex) in infoheaders">
                      <td :key="headerindex">
                        <span v-if="header.key === 'modified_on'">{{
                          data[header.key] | infoDate
                        }}</span>
                        <span
                          v-else-if="header.key === 'updated_by' || header.key === 'requested_by'"
                        >
                          <img
                            v-if="![12, 13].includes(roleId) && 
                              data[header.key].role_id && [12, 13].includes(data[header.key].role_id)
                            "
                            class="emergo-record test"
                            src="/static/images/icons/emergo_record.svg"
                            alt=""
                          />
                          <div v-else class="d-flex align-items-center">
                            <img
                              src="/static/images/icons/profile_icon.svg"
                              class="profile-img"
                              alt=""
                              v-if="data[header.key].name"
                            />
                            <span>{{ data[header.key].name || '-' }}</span>
                          </div>
                        </span>
                        <span v-else>{{ data[header.key] || '-' }}</span>
                      </td></template
                    >
                  </tr>
                  <tr v-if="!productInfoData.length">
                    <td colspan="100%" class="center">No Status updates</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'infopage'"></loader>
        </div>
      </div>
    </div>
    <div id="confrimAddPopup" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#confrimAddPopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/info_icon_active.svg" class="info-icon" />
            <div class="sub-header">Only add product if instructed to do so by Emergo</div>
            <div class="sub-text">
              Please proceed, if you are sure about adding the product as per the instructions of
              Emergo.
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#confrimAddPopup"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="openAddProductTracker()"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <contacts-popup
      :checkRolePermissions="checkRolePermissions"
      :selectedSingleProduct="selectedSingleProduct"
      :usersListData="usersList"
      :countries="metaData.product_tracker_countries"
      @close="selectedSingleProduct = null"
    ></contacts-popup>
    <loader :loadingStatus="loaderStatus === 'listpage'"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
// import groupBy from 'lodash/groupBy';
import { Popover, Tooltip } from 'element-ui';
import SearchBox from '../../UIComponents/SearchBox.vue';
import Pagination from '../../UIComponents/Pagination.vue';
import BaseTooltip from '../../Common/BaseTooltip.vue';
import ContactsPopup from './ContactsPopup.vue';
import {
  getProductsListByAccountId,
  getProductTrackerInfoById,
  getProductTrackerMetaData,
  removeProducts,
  removeProductRequestByPM,
  requestProductModification,
  requestProductRemoval,
  updateProductStatus,
  approveProductRemoval,
  getProductRemovalStatus
} from '../../../apis/productTracker';
import permissionsList from '../../UIComponents/mixins/rbacPermissionsMixin';
import Loader from '../../UIComponents/Loader.vue';
import { getTeamMembers } from '../../../apis/team';
import { getUserData } from '../../../apis/profile';

export default {
  mixins: [permissionsList],
  props: ['roleId', 'account_id', 'userId'],
  data() {
    return {
      disableContactNum: 0,
      permissions: [],
      metaData: {},
      searchText: '',
      totalPages: 1,
      total: 0,
      maxVisiblePages: 4,
      perPage: 1,
      currentPage: 1,
      dateFormat: 'YYYY-MM-DD',
      chevronList: {
        isDateChevron: 'Date',
        isCountryChevron: 'Country'
      },
      types: {
        label: 'directivesInsights',
        countryId: 'country_id',
        countryName: 'country_name'
      },
      filterOptions: null,
      products: [],
      headers: [
        {
          name: 'Product Family',
          key: 'family_name',
          width: null
        },
        {
          name: 'GMDN/EMDN',
          key: 'gmdn_emdn_cd',
          width: 14
        },
        {
          name: 'Classification',
          key: 'class_code',
          width: 16
        },
        {
          name: 'Additional Legislation',
          key: 'directives',
          width: 16
        },
        {
          name: 'Trade Names',
          key: 'trade_name',
          width: 16
        },
        {
          name: 'Status',
          key: 'workflow_status_id',
          width: 14
        }
      ],
      infoheaders: [
        {
          name: 'Modified on',
          key: 'modified_on'
        },
        {
          name: 'Status',
          key: 'status'
        },
        {
          name: 'Updated By',
          key: 'updated_by'
        },
        {
          name: 'Requested By',
          key: 'requested_by'
        }
      ],
      showheader: false,
      selectAllProducts: false,
      selectedProducts: [],
      sortOrders: {},
      changeClass: false,
      preferences: {},
      activeTab: '',
      requestModificationMessage: '',
      selectedSingleProduct: null,
      selectedProductType: '',
      selectedProductStatus: null,
      loaderStatus: '',
      initialCalls: false,
      infoActive: false,
      isRemovedflag: false,
      productInfoData: [],
      marketCountSummary: [],
      primaryUser: null,
      secondaryUsers: [],
      usersList: []
    };
  },
  components: {
    SearchBox,
    Pagination,
    BaseTooltip,
    'el-popover': Popover,
    'el-tooltip': Tooltip,
    Loader,
    ContactsPopup
  },
  computed: {
    checkRolePermissions() {
      if (
        this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_DRAFT') ||
        this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_REMOVAL') ||
        this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_UPDATE') ||
        this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_PRODUCT') ||
        this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REMOVE_PRODUCT')
      ) {
        return true;
      }
      return false;
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      const returnVal = value.replace('_', ' ').toString();
      return returnVal
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
    infoDate(date) {
      if (!date) return '';
      return moment(date).format('Do MMMM, YYYY, hh:mm A');
    }
  },
  methods: {
    filteredOptions(value) {
      if (value === 7 || value === 8) {
        const newOptions = cloneDeep(this.metaData.work_flow_statuses);
        newOptions.forEach((a) => {
          a.$isDisabled = a.id < 7;
        });
        return newOptions;
      }
      return this.metaData.work_flow_statuses;
    },
    removeSelected() {
      this.selectAllProducts = false;
      this.selectAll();
      this.getProductTrackersList();
    },
    checkCountFromMarkets(id) {
      const count = this.marketCountSummary.find((e) => e.country_id === id).total_count;
      return count && count > 0;
    },
    checkAllMarkets() {
      return this.marketCountSummary.some((e) => e.total_count > 0);
    },
    getHeaderWidth(header) {
      if (!this.checkRolePermissions) {
        if (
          (this.activeTab === 14 || this.activeTab === 216) &&
          header.name !== 'Status' &&
          header.name !== 'Product Family'
        ) {
          return `${100 / 5}%`;
        }
        return `${100 / 6}%`;
      }
      if (
        (this.activeTab === 14 || this.activeTab === 216) &&
        header.name !== 'Status' &&
        header.name !== 'Product Family'
      ) {
        return `${header.width + 4}%`;
      }
      return header.width ? `${header.width}%` : '';
    },
    async validateFeatures() {
      this.loaderStatus = 'listpage';
      this.permissions = [];
      const servicesList = ['REPRESENTATION_RESOURCES'];
      const modulesList = ['REPRESENTATION_RESOURCES_PRODUCT_TRACKER'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      this.loaderStatus = '';
    },
    checkMenuPermission(statusId) {
      if (
        statusId &&
        statusId === 1 &&
        this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_DRAFT')
      ) {
        return true;
      }
      if (statusId && statusId > 1) {
        if (
          this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_UPDATE') ||
          this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_REMOVAL') ||
          this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_PRODUCT') ||
          this.permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REMOVE_PRODUCT')
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    setTab(tabId) {
      if (this.activeTab !== tabId) {
        this.activeTab = tabId;
        this.selectAllProducts = false;
        this.selectedProducts = [];
        this.getProductTrackersList();
      }
    },
    pagechanged(currentPage) {
      if (currentPage) this.currentPage = currentPage;
      // this.fromRecords = this.currentPage * this.perPage - (this.perPage - 1);
    },
    setDefaultFilterOptions(filterOptions) {
      if (!filterOptions.isFilterSelected) {
        this.filterOptions = null;
      } else {
        this.filterOptions = cloneDeep(filterOptions);
      }
    },
    async getList() {
      this.initialCalls = false;
      await this.getProductTrackersList();
      this.initialCalls = true;
    },
    selectAll() {
      this.selectedProducts = [];
      if (this.selectAllProducts) {
        this.products.forEach((file) => {
          if (
            file.workflow_status_id &&
            file.workflow_status_id !== 1 &&
            file.workflow_status_id !== 6 &&
            this.checkMenuPermission(file.workflow_status_id)
          ) {
            this.selectedProducts.push(file);
          }
        });
      }
    },
    updateSelection(each, event) {
      if (!event.target.checked) {
        this.selectAllProducts = false;
        const i = this.selectedProducts.findIndex((file) => file.id === each.id);
        if (i > -1) this.selectedProducts.splice(i, 1);
      } else if (event.target.checked) {
        if (this.selectedProducts.findIndex((file) => file.id === each.id) === -1) {
          this.selectedProducts.push(each);
        }
      }
      if (
        this.selectedProducts.length ===
        this.products.filter(
          (e) =>
            e.workflow_status_id &&
            e.workflow_status_id !== 1 &&
            e.workflow_status_id !== 6 &&
            this.checkMenuPermission(e.workflow_status_id)
        ).length
      ) {
        this.selectAllProducts = true;
      }
    },
    sortBy(field) {
      this.sortOrders[field] = !this.sortOrders[field];
      this.products.sort((item1, item2) => {
        let x;
        let y;
        if (field === 'workflow_status_id') {
          x = item1[field] ? this.getStatusName(item1[field]).toLowerCase() : '';
          y = item2[field] ? this.getStatusName(item2[field]).toLowerCase() : '';
        } else {
          x = item1[field] ? item1[field].toLowerCase() : '';
          y = item2[field] ? item2[field].toLowerCase() : '';
        }
        if (x < y) {
          return this.sortOrders[field] ? -1 : 1;
        }
        if (x > y) {
          return this.sortOrders[field] ? 1 : -1;
        }
        return 0;
      });
    },
    // To Disable modal on select of tracker dots
    menuDropdown(event) {
      $('td.sticky').css('z-index', 0);
      $(event.target).closest('td.sticky').css('z-index', 1);
      this.dropDownMenuDisable = true;
      this.changeClass = false;
      let height = 0;
      if (window.screen.width > 1024) height = window.innerHeight;
      else height = $('.producttracker-data').height() + 80;
      if (event.pageY > height - 90) {
        this.changeClass = true;
      } else {
        this.changeClass = false;
      }
    },
    toggle(data, e) {
      e.target.classList.toggle('chevron-icon-up');
      $(e.target).closest('tr').toggleClass('collpase-row');
      data.forEach((each) => {
        $(`.child-${each.id}`).toggle();
      });
    },
    openRequestModification(type, selectedProduct) {
      this.selectedProductType = type;
      this.selectedSingleProduct = selectedProduct || null;
      $('#requestModificationPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    closeRequestPopup() {
      $('#requestModificationPopup').modal('hide');
      $('#clientModificationRequestConfirmationPopup').modal('hide');
      this.requestModificationMessage = '';
      this.selectedProductType = '';
      this.selectedSingleProduct = null;
    },
    async openRemovalPopup(type, selectedProduct, key) {
      this.loaderStatus = 'listpage';
      const res = await getProductRemovalStatus(selectedProduct.id, selectedProduct.country_id);
      this.loaderStatus = '';
      if (res && res.data && res.data[key]) {
        this.selectedProductType = type;
        this.selectedSingleProduct = selectedProduct || null;
        $('#confirmProductRemoval').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (res && res.data && !res.data[key]) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Client has not requested to remove this product. Please raise a request to client to remove the product.',
          group: 'custom-notification'
        });
        this.getProductTrackersList();
      } else {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch the details of client request(s).',
          group: 'custom-notification'
        });
      }
    },
    async openPMRequestRemovalPopup(type, selectedProduct, key) {
      this.loaderStatus = 'listpage';
      const res = await getProductRemovalStatus(selectedProduct.id, selectedProduct.country_id);
      this.loaderStatus = '';
      if (res && (!res.data || (res.data && !res.data[key]))) {
        this.selectedProductType = type;
        this.selectedSingleProduct = selectedProduct || null;
        $('#requestRemoveProductPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (res && res.data && res.data[key]) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Client has already requested to remove this product. Please try to remove the product.',
          group: 'custom-notification'
        });
        this.getProductTrackersList();
      } else {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch the details of client request(s).',
          group: 'custom-notification'
        });
      }
    },
    openClientRemovalPopup(type, selectedProduct) {
      this.selectedProductType = type;
      this.selectedSingleProduct = selectedProduct || null;
      $('#clientRequestRemovalPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    approvedRequest(type, selectedProduct) {
      this.selectedProductType = type;
      this.selectedSingleProduct = selectedProduct || null;
      $('#approveRequestPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async approvedProductRequest() {
      const data = {
        approve_flag: this.selectedProductType === 'approval',
        country_id: this.activeTab,
        prod_trckr_id: this.selectedSingleProduct.id
      };
      this.loaderStatus = 'approveProduct';
      const res = await approveProductRemoval(data);
      this.loaderStatus = '';
      if (res && res.status_code === 200) {
        $('#approveRequestPopup').modal('hide');
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text:
            this.selectedProductType === 'approval'
              ? 'Approved successfully'
              : 'Denied successfully',
          group: 'custom-notification'
        });
        this.selectedProductType = '';
        this.selectedSingleProduct = null;
        this.getProductTrackersList();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: `Unable to send ${this.selectedProductType} request!`,
          group: 'custom-notification'
        });
      }
    },
    async openInfoPopup(each) {
      $('#productTrackerInfoPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
      this.loaderStatus = 'infopage';
      this.productInfoData = await getProductTrackerInfoById(each.id, each.country_id);
      this.loaderStatus = '';
    },
    async openContactsInfoPopup(each) {
      this.selectedSingleProduct = { ...each };
      $('#productTrackerContactsInfoPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async requestModification() {
      const data = {
        tracker_instances: [],
        message: this.requestModificationMessage
      };
      if (this.selectedProductType === 'single') {
        data.tracker_instances.push({
          market_ids: [this.activeTab],
          product_tracker_instance_id: this.selectedSingleProduct.id
        });
      } else {
        this.selectedProducts.forEach((p) => {
          data.tracker_instances.push({
            market_ids: [this.activeTab],
            product_tracker_instance_id: p.id
          });
        });
      }
      this.loaderStatus = 'requestModification';
      const res = await requestProductModification(data);
      this.loaderStatus = '';
      if (res && res.status_code === 200) {
        this.closeRequestPopup();
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Request for product(s) modification sent successfully',
          group: 'custom-notification'
        });
        this.selectedProductType = '';
        this.selectedSingleProduct = null;
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to send product(s) modification request!',
          group: 'custom-notification'
        });
      }
    },
    async submitRequestRemoval() {
      const data = {
        tracker_instances: [],
        message: ''
      };
      if (this.selectedProductType === 'single') {
        data.tracker_instances.push({
          market_ids: [this.activeTab],
          product_tracker_instance_id: this.selectedSingleProduct.id
        });
      } else {
        this.selectedProducts.forEach((p) => {
          data.tracker_instances.push({
            market_ids: [this.activeTab],
            product_tracker_instance_id: p.id
          });
        });
      }
      this.loaderStatus = 'requestRemoveProduct';
      const res = await requestProductRemoval(data);
      this.loaderStatus = '';
      if (res && res.status_code === 200) {
        $('#clientRequestRemovalPopup').modal('hide');
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Request for product(s) removal sent successfully',
          group: 'custom-notification'
        });
        this.selectedProductType = '';
        this.selectedSingleProduct = null;
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to send product(s) removal request!',
          group: 'custom-notification'
        });
      }
    },
    async removeSelectedProducts() {
      const data = {
        tracker_instances: []
      };
      if (this.selectedProductType === 'single') {
        data.tracker_instances.push({
          market_ids: [this.activeTab],
          product_tracker_instance_id: this.selectedSingleProduct.id
        });
      } else {
        this.selectedProducts.forEach((p) => {
          data.tracker_instances.push({
            market_ids: [this.activeTab],
            product_tracker_instance_id: p.id
          });
        });
      }
      this.loaderStatus = 'removeProduct';
      const res = await removeProducts(data);
      this.loaderStatus = '';
      if (res && res.status_code === 200) {
        $('#confirmProductRemoval').modal('hide');
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Product(s) removed successfully',
          group: 'custom-notification'
        });
        this.getProductTrackersList();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to remove products!',
          group: 'custom-notification'
        });
      }
    },
    editProductTracker(id, countryId) {
      sessionStorage.setItem('selectedProductTrackerDetails', JSON.stringify({ id, countryId }));
      this.$router.push({
        name: 'EditProductTracker',
        params: { metaData: this.metaData, permissions: this.permissions }
      });
    },
    openAddProductTracker() {
      this.$router.push({
        name: 'AddProductTracker',
        params: { metaData: this.metaData, permissions: this.permissions }
      });
    },
    getStatusName(statusid) {
      return this.metaData.work_flow_statuses.find((e) => e.id === statusid).name;
    },
    getStatus(statusid) {
      return this.metaData.work_flow_statuses.find((e) => e.id === statusid);
    },
    async updateStatusCall(selectedoption, each) {
      if (each.workflow_status_id !== selectedoption.id) {
        this.loaderStatus = 'listpage';
        const res = await updateProductStatus(each.id, each.country_id, selectedoption.id);
        this.loaderStatus = '';
        if (res && res.status_code === 200) {
          each.workflow_status_id = selectedoption.id;
          this.clearNotifications();
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Status updated successfully',
            group: 'custom-notification'
          });
          this.getProductTrackersList();
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Unable to updated status!',
            group: 'custom-notification'
          });
        }
        this.selectedProductStatus = null;
      }
    },
    async getProductTrackerMetaData() {
      this.loaderStatus = 'listpage';
      this.metaData = await getProductTrackerMetaData();
      this.loaderStatus = '';
    },
    async getProductTrackersList() {
      this.loaderStatus = 'listpage';
      const requestData = {
        filter: {
          country_ids: [this.activeTab],
          account_id: this.account_id,
          status_ids: this.metaData.work_flow_statuses.filter((e) => e.id !== 6).map((e) => e.id)
        },
        pagination: {
          from: this.currentPage,
          to: this.perPage
        },
        search: this.searchText
      };
      if (this.isRemovedflag) requestData.filter.status_ids = [6];
      const res = await getProductsListByAccountId(requestData);
      this.total = res.total_records_count || 0;
      this.products = res.result_data || [];
      this.marketCountSummary = res.market_count_summary;
      this.loaderStatus = '';
      const market = this.marketCountSummary.find((e) => e.country_id === this.activeTab);
      if (market && market.total_count === 0) {
        const rec = this.marketCountSummary.find((e) => e.total_count > 0);
        if (rec) {
          this.activeTab = rec.country_id;
          await this.getProductTrackersList();
        }
      }
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    async removeProductRequestByPM() {
      const data = {
        email_ids: {
          cc_user_ids: this.secondaryUsers,
          to_user_id: this.primaryUser
        },
        remove_details_data: []
      };
      if (this.selectedProductType === 'single') {
        data.remove_details_data.push({
          country_id: this.activeTab,
          prod_trckr_id: this.selectedSingleProduct.id
        });
      } else {
        this.selectedProducts.forEach((p) => {
          data.remove_details_data.push({
            country_id: this.activeTab,
            prod_trckr_id: p.id
          });
        });
      }
      this.loaderStatus = 'requestRemoveProductPopup';
      const res = await removeProductRequestByPM(data);
      this.loaderStatus = '';
      if (res && res.status_code === 200) {
        $('#requestRemoveProductPopup').modal('hide');
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Request to remove product(s) sent successfully',
          group: 'custom-notification'
        });
        this.primaryUser = null;
        this.secondaryUsers = [];
        this.getProductTrackersList();
      } else {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: res && res.message ? res.message : 'Unable to request remove product(s)!',
          group: 'custom-notification'
        });
      }
    },
    selectedContact(item, limit = 0) {
      if (this.secondaryUsers.findIndex((c) => item === c) === -1) {
        this.secondaryUsers.push(item);
        if (limit && this.secondaryUsers.length > limit) {
          this.$nextTick(() => {
            this.secondaryUsers.splice(limit, this.secondaryUsers.length);
          });
        }
      } else {
        this.secondaryUsers = this.secondaryUsers.filter((c) => item !== c);
      }
    },
    getContact(id) {
      return this.usersList.find((f) => f.user_id === id) || {};
    },
    async getTeamMembers() {
      this.loaderStatus = 'requestRemoveProductPopup';
      const userData = JSON.parse(localStorage.getItem('userData')) || (await getUserData());
      const rep = userData.account_type_id === 2 || userData.account_type_id === 4 ? 1 : 0;
      const usersList = await getTeamMembers(rep);
      this.loaderStatus = '';
      this.usersList = usersList.filter(
        (user) => (user.role_id === 9 || user.role_id === 8) && !user.is_restricted
      );
    },
    getUserFullName(option) {
      const user = this.usersList.find((f) => f.user_id === option);
      return user ? `${user.first_name} ${user.last_name}` : '';
    }
  },
  watch: {
    $route() {},
    headers() {
      if (this.headers.length) {
        this.showheader = true;
      } else this.showheader = false;
    }
  },
  async created() {
    this.headers.forEach((header) => {
      this.sortOrders[header.key] = -1;
    });
    await this.validateFeatures();
    await this.getProductTrackerMetaData();
    if (this.$route.params.countryId) {
      if (
        this.metaData.product_tracker_countries.find(
          (e) => e.country_id === parseInt(this.$route.params.countryId, 10)
        )
      ) {
        this.activeTab = parseInt(this.$route.params.countryId, 10);
        this.searchText = this.$route.params.device;
      } else {
        this.activeTab = this.metaData.product_tracker_countries
          ? this.metaData.product_tracker_countries[0].country_id
          : '';
      }
    } else {
      this.activeTab = this.metaData.product_tracker_countries
        ? this.metaData.product_tracker_countries[0].country_id
        : '';
    }
    await this.getProductTrackersList();
    this.initialCalls = true;
    $('#requestRemoveProductPopup').on('show.bs.modal', async () => {
      await this.getTeamMembers();
    });
  }
};
</script>
<style scoped>
.custom-margin-right {
  margin-right: 40px;
}
.modal-header.pb-15 {
  padding-bottom: 15px;
}
.info-tabs p,
.info-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  word-break: break-word;
  text-align: left;
}
.info-tabs-header {
  font-weight: 600 !important;
}
.info-tabs li:not(:last-child) {
  margin-bottom: 15px;
}
.info-img {
  cursor: pointer;
}
.pr-30 {
  padding-right: 30px;
}
.pl-25 {
  padding-left: 25px;
}
.wd-40 {
  width: 50px;
}
.pt-15 {
  padding-top: 15px;
}
.ml-5 {
  margin-left: 5px;
}
.product-container {
  padding: 25px 25px 0;
}
.custom-margin {
  margin: 0 10px;
}
.title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.header_box {
  border-bottom: 0.5px solid #bdbdbd;
  padding-bottom: 17px;
  padding-top: 17px;
}
.header_box p {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  margin: 0;
}
.header_box.pb-20 {
  padding-bottom: 20px;
}
.header_box .product-count {
  font-size: 18px;
  line-height: 22px;
}
.header-img-size {
  width: 18px;
  height: 18px;
  vertical-align: top;
  margin: 2px 2px 0 0;
}
.header-font {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 19px;
  text-align: right;
}

.header-font.removed-label {
  position: relative;
  top: 3px;
}
.header_box a {
  display: block;
  text-align: right;
  line-height: 22px;
}
.rep_resources_table {
  vertical-align: unset;
}
.rep_resources_table .table {
  margin: 0;
}
.rep_resources_table .table > tbody > tr:hover > td {
  background-color: #fff;
}
.rep_resources_table .table > tbody > tr > td,
.status-table.table > tbody > tr > td {
  font-size: 16px;
  border-bottom: 1px solid #bdbdbd;
  color: #606266;
  padding: 16px 10px !important;
}
.rep_resources_table .table > thead > tr > th,
.status-table.table > thead > tr > th {
  font-weight: 500;
  font-size: 14px;
  color: #0b3c61;
  padding: 16px 10px !important;
  border-bottom: 1px dashed #bdbdbd !important;
}
.status-table.table > tbody > tr:last-child > td {
  border-bottom: none;
}
.table > thead > tr > th:hover .arrow {
  opacity: 1;
}
.table > thead > tr > th .arrow.desc {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #c4c4c4;
}
.table > thead > tr > th .arrow.asc {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #c4c4c4;
}
.rep_resources_table > thead {
  background: #fff;
}
.status-table > thead {
  background: #fff;
  border-top: 1px solid #bdbdbd;
}
.rep_resources_table .table > tbody > tr.custom-padding > td:first-child,
.rep_resources_table .table > thead > tr.custom-padding > th:first-child {
  padding: 16px 10px 16px 25px !important;
}
.rep_resources_table .table > tbody > tr > td:last-child,
.rep_resources_table .table > tbody > tr > td:last-child {
  padding: 16px 25px 16px 10px !important;
}
.rep_resources_table .cell {
  word-break: break-word;
}
.rep_resources_table .dropdown-menu.pull-left {
  right: 0px;
  left: auto;
  top: 25px;
  min-width: 200px;
}
.rep_resources_table ul.dropdown-menu.pull-left li {
  padding-left: 10px;
  padding-bottom: 5px;
}
.rep_resources_table .dropdown-menu {
  z-index: 3;
  left: -3px;
  top: 35px;
}
.rep_resources_table .dropdown-toggle::after {
  background-image: url(/static/images/icons/menudots_icon.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  float: right;
}
.rep_resources_table .disable-three-dots .dropdown-toggle::after {
  background-image: url(/static/images/icons/menudots_icon.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  float: right;
  opacity: 0.4;
}
.rep_resources_table .dropdown.open:not(.disable-three-dots) .dropdown-toggle::after {
  background-image: url(/static/images/icons/menudots_icon_active.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  float: right;
}

.rep_resources_table .export-activity-menu .dropdown-menu::after {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  display: unset;
  position: absolute;
  pointer-events: none;
  content: '';
  visibility: visible;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  width: 18px;
  height: 18px;
  background: #fff;
  z-index: -10;
  top: -10px;
  left: 16px;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin: auto;
  -webkit-transition: all 0.5s ease-in 0s;
}
.addReverse {
  top: auto !important;
  bottom: 15px;
  margin-bottom: initial;
}
.rep_resources_table .export-activity-menu .dropdown-menu.addReverse::after {
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  top: auto;
  bottom: -10px;
}

.rep_resources_table .export-activity-menu.dropdown-export {
  float: none;
}
.rep_resources_table .fa.menu-dots {
  cursor: pointer;
  font-size: 22px;
}
.chevron-icon {
  -moz-transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
  cursor: pointer;
}
.chevron-icon.chevron-icon-up {
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.rep_resources_table tr.parent.collpase-row > td {
  border: none;
}

.notification_box {
  display: flex;
  align-items: center;
  min-height: 50vh;
  margin: auto;
  width: 100%;
  justify-content: center;
}
.notification_text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 17px;
}
.sort {
  padding-left: 8px;
}
.sort.asc img {
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.modal-content {
  border-radius: 10px;
}
.modal-header {
  padding: 25px 25px 0;
  background: #fff;
  border-radius: 10px;
  border: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.modal-body {
  padding: 15px 35px;
}
.modal-footer {
  background: #fff;
  border-radius: 10px;
  border: 0;
  padding: 30px 35px;
}
.close-icon {
  position: absolute;
  top: 18px;
  right: 18px;
}
.modal-dialog .form-control.text-box {
  height: 150px;
  resize: none;
}
.info-popup .info-table {
  min-height: 200px;
  max-height: 320px;
  overflow-y: auto;
}
.info-popup {
  width: auto;
  min-width: 600px;
}
.input-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 10px;
}
.modal-status-header {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.export-activity-menu .dropdown-menu > li > a {
  padding: 7px 10px;
  font-weight: 400;
  font-size: 16px !important;
  line-height: 19px;
  color: #0b3c61;
}
.dropdown-menu > li > a.text-color-delete-red,
.text-color-delete-red:hover,
.dropdown-menu > li > a.text-color-delete-red:hover {
  color: #b00505;
}

.dropdown-menu > li > a.text-color-blue,
.text-color-blue:hover,
.dropdown-menu > li > a.text-color-blue:hover {
  color: #0b3c61;
}
.submit-popup .modal-body .sub-header {
  color: rgba(0, 0, 0, 0.7);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  padding-top: 25px;
  padding-bottom: 20px;
}
.submit-popup .modal-body .sub-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
  padding-bottom: 10px;
}
.submit-popup .modal-body {
  width: 92%;
  margin: auto;
}
.submit-popup .modal-footer {
  width: 90%;
  margin: auto;
  padding: 30px 15px;
}
.submit-popup .modal-dialog {
  width: 480px;
}
::v-deep .multiselect.multiselect-single-dropdown.status-dropdown {
  width: 240px;
}
.info-icon {
  width: 58px;
  height: 58px;
}
.wd-370 {
  width: 360px;
}
.mr-20 {
  margin-right: 20px;
}
.custom-display {
  display: flex;
  justify-content: flex-end;
}
.submit-popup .modal-header {
  padding: 25px;
}
.display-flex {
  display: flex;
}
.selected-names {
  background: rgba(201, 226, 244, 0.5);
  border-radius: 28px;
  padding: 8px 15px 8px 17px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #0b3c61;
  margin-right: 10px;
  display: inline-block;
}
.modal-note {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 20px;
}
.required-astreisk {
  color: #b00505;
  margin-left: 5px;
}
.profile-img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.emergo-record {
  width: 100px;
  height: 28px;
  object-fit: cover;
}
@media screen and (max-width: 767px) {
  .submit-popup .modal-dialog {
    width: auto;
  }
  .product-container {
    padding: 25px 15px 0;
  }
  .admin-col .tableUpdateIcons span {
    padding: 0 5px 10px 0;
  }
  .xs-mt-20 {
    margin-top: 20px;
  }
  .tool-container {
    padding: 15px 0 0;
  }
  .pr-25 {
    padding-right: 15px;
  }
  .rep_resources_table .table {
    width: 1300px;
    max-width: unset;
  }
  .rep_resources_table {
    overflow-x: scroll;
  }
  .rep_resources_table .table tr .sticky {
    position: sticky;
    left: 0;
    z-index: 0;
    background: white;
  }
  .rep_resources_table .table tr .export-activity-menu.open:parent {
    z-index: 2;
  }
  .rep_resources_table .table tr .sticky-checkbox {
    position: sticky;
    z-index: 0;
    left: 65px;
    background: white;
  }
  .rep_resources_table .table tr .sticky.border-shadow::before,
  .rep_resources_table .table tr .sticky-checkbox::before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 3px 0px 4px -1px rgba(0, 0, 0, 0.1);
    display: block;
    top: 0px;
    z-index: -1;
  }
  .rep_resources_table th .arrow {
    opacity: 1;
  }
  .flag-icon {
    z-index: -1;
  }
  .xs-p-0 {
    padding: 0;
  }
  .xs-mt-20 {
    margin-top: 20px;
  }
  .xs-mb-20 {
    margin-bottom: 20px;
  }
  .rep_resources_table .table > tbody > tr > td:last-child,
  .rep_resources_table .table > tbody > tr > td:last-child {
    padding: 16px 15px 16px 10px !important;
  }
  .xs-pr-10 {
    padding-right: 10px;
  }
  .info-popup {
    min-width: auto;
  }
  .info-popup.modal-dialog {
    max-width: 90%;
  }
  .info-popup .info-table {
    overflow-x: scroll;
    max-width: 100%;
  }
  .info-popup .table {
    width: 600px;
    max-width: unset;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .rep_resources_table .table {
    width: 1300px;
    max-width: unset;
  }
  .rep_resources_table {
    overflow-x: scroll;
  }
  .rep_resources_table .table tr .sticky {
    position: sticky;
    left: 0;
    z-index: 0;
    background: white;
  }
  .rep_resources_table .table tr .export-activity-menu.open:parent {
    z-index: 2;
  }
  .rep_resources_table .table tr .sticky-checkbox {
    position: sticky;
    z-index: 0;
    left: 65px;
    background: white;
  }
  .rep_resources_table .table tr .sticky.border-shadow::before,
  .rep_resources_table .table tr .sticky-checkbox::before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.1);
    display: block;
    top: 0px;
    z-index: -1;
  }
  .rep_resources_table th .arrow {
    opacity: 1;
  }
}
@media (min-width: 1030px) and (max-width: 1477px) {
  .custom-margin-right {
    margin-right: 15%;
  }
}
</style>
